export default __webpack_public_path__ + "static/cm-98e54a4134fa32cde9451088f01352d5.svg";